// Per-run view of a config's calibration parameters.
//
// A run whose dynamic pressure was synthesized (no probe — DynPres built from
// air density × ground speed, flagged on run.solve.selections.dynamic_pressure)
// already carries true dynamic pressure, so the pitot correction cp_corr must
// NOT be applied to it. Mirrors CalibrationConst.for_dynamic_pressure on the
// backend: any client-side calculation multiplying by cp_corr must use this
// per-run view, never the raw config record.

export const isSyntheticDynamicPressure = (run: any): boolean =>
  run?.solve?.selections?.dynamic_pressure?.synthetic === true;

// 'synthetic' | 'measured' when the solve recorded a dynamic-pressure
// selection; null for unprocessed runs or solves predating the field.
export const dynamicPressureSource = (run: any): 'synthetic' | 'measured' | null => {
  const dp = run?.solve?.selections?.dynamic_pressure;
  if (!dp) return null;
  return dp.synthetic === true ? 'synthetic' : 'measured';
};

export const effectiveCalibration = (calibration: any, run: any): any => {
  if (!calibration || !isSyntheticDynamicPressure(run)) return calibration;
  return { ...calibration, cp_corr: 1 };
};
